import React, { FunctionComponent } from "react";
import { ICardElementWithChildren } from "backend/model/model";
import TextElement from "reportengine/TextElement";
import Text from "reportengine/Text";
import Report from "reportengine/Report";
import Slide from "reportengine/Slide";
import { createReport, saveBlob } from "reportengine/createReport";
import reportContextToRequest from "./reportContextToRequest";
import DomElement from "reportengine/DomElement";
import SlowRenderingComponent from "reportengine/testcomponents/SlowRenderingComponent";
import ProgressModal from "design/components/progress/ProgressModal";
import Portion from "reportengine/Portion";
import PerformanceTrendView from "design/components/charts/PerformanceTrendView";
import { Series } from "design/components/charts/types";
import { formatDate, getDateFromMEAValue } from "utils/utils";
import PerformanceTrend from "components/PerformanceTrend";
import InitiativeProgressCard from "design/components/cards/InitiativeProgressCard/InitiativeProgressCard";
import ProgressBar from "design/components/progress/ProgressBar";
import { PerformanceDonut } from "design/components/charts/PerformanceDonut";
import SlideTable from "reportengine/SlideTable";
import SlideTableRow from "reportengine/SlideTableRow";
import useHierarchy from "backend/hooks/elements/useHierarchy";
import InitiativeSlide from "./slides/InitiativeSlide";

const InitiativeReport = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
    filetype: string;
    onClose?: () => void;
  }>
) => {
  const { item, filetype } = props;
  const {
    isLoading: isChildrenLoading,
    data: children,
    isPreviousData,
    isRefetching,
  } = useHierarchy(item.id);
  const [progress, setProgres] = React.useState(0);
  const [blob, setBlob] = React.useState<null | Blob>(null);

  if (isChildrenLoading || isPreviousData || isRefetching) {
    return null;
  }
  return (
    <div>
      <Report
        template="/templates/report_en.pptx"
        onNothingToRender={() => {}}
        onProgress={(value) => {
          setProgres(value);
          console.log("slide progress ", value);
        }}
        onReadyToRender={async (report) => {
          setProgres(95);
          const blob = await createReport(
            await reportContextToRequest(report, item.symbol, filetype)
          );
          setBlob(blob);
          setProgres(100);
        }}
      >
        <Slide index={0}>
          <TextElement slideElement="title">Initiative Details</TextElement>
          <TextElement slideElement="subtitle">{item.name}</TextElement>
          <TextElement slideElement="footer">
            {item.period?.name || ""}
          </TextElement>
        </Slide>
        <InitiativeSlide item={item} />
      </Report>
      <ProgressModal
        isOpen
        onClose={() => {
          if (props.onClose) {
            props.onClose();
          }
        }}
        isComplete={!!blob}
        cancelClickHandler={props.onClose}
        completedClickHandler={() => {
          if (blob) {
            saveBlob(`${item.symbol}.${filetype}`, blob);
          }
        }}
        downloadText="Download"
        progress={progress}
        statusText="Exporting..."
      />
    </div>
  );
};

export default InitiativeReport;
